import { Box, TextField } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';

interface SentenceCompletionProps {
    prompt: string;
    onChange: (newPrompt: string) => void
}

function splitStringWithDelimiter(str: string, delimiter: string) {
    const regex = new RegExp(`(${delimiter})`, 'g');
    return str.split(regex);
}

const PromptCompletion: React.FC<SentenceCompletionProps> = ({ prompt, onChange }) => {
    const tokenRegex = /%token%/g;
    const tokens = prompt.match(tokenRegex) || [];
    const [tokenValues, setTokenValues] = useState<string[]>(Array(tokens.length).fill(''));

    const newPrompt = useEffect(() => {
        let newPrompt = prompt;
        let index = 0;

        while (newPrompt.indexOf('%token%') > -1) {
            newPrompt = newPrompt.replace('%token%', tokenValues[index]);
            index++;
        }

        onChange(newPrompt)
    }, [prompt, tokens])

    const handleTokenChange = (index: number, value: string) => {
        const updatedTokens = [...tokenValues];
        updatedTokens[index] = value;
        setTokenValues(updatedTokens);
    };

    let tokenIndex = -1;

    const renderSentence = () => {
        const parts = splitStringWithDelimiter(prompt, '%token%')

        tokenIndex = -1;

        return parts.map((part: never, index) => {
            if (tokens.includes(part)) {
                tokenIndex++;

                const i = tokenIndex;
                return (
                    <TextField
                        sx={{ ml: 2, mr: 2 }}
                        size="small"
                        key={index}
                        type="text"
                        value={tokenValues[i]}
                        onChange={(e) => handleTokenChange(i, e.target.value)}
                        placeholder={`%token${i + 1}%`}
                    />
                );
            }
            return <span key={index}>{part}</span>;
        });
    };

    return (
        <Box >{renderSentence()}</Box>
    );
};

export default PromptCompletion;
